import React from 'react';
import * as am4charts from '@amcharts/amcharts4/charts';
import { Tooltip } from '@components/tooltip/tooltip';


export const createChartTooltipAdapter = (t: any, isDeviceChart?: boolean) => {
  const ns = 'translation';
  return (_: any, target: any) => {
    let dataItem = target.getSeriesDataItem(
        target.chart.series.getIndex(0) as am4charts.XYSeries,
        target.toAxisPosition((target.chart as any).cursor.xPosition),
        true
      ),
      data = dataItem.dataContext;

    return `${data.count} ${t(isDeviceChart ? 'DEVICE' : 'BATTERY_FIRST_CAPITAL', { ns, count: data.count })}`;
  };
};

export const getTitle = (t: any, title: string, isDeviceChart = false): JSX.Element => {
  const ns = 'batteryEssentialsChart';
  const titleText = t(title, { ns });
  return (
    <>
      {titleText}
      <Tooltip
        key='chart-tooltip'
        placement='bottom-start'
        popperContent={
          <div className="battery-charts-title-popover_text">
            {t(isDeviceChart ? 'DEVICE_CHART_TITLE_TOOLTIP' : 'BATTERY_CHART_TITLE_TOOLTIP', { ns })}
          </div>
        }
      >
        <i
          aria-label='about chart title'
          className="battery-chart-title-icon fa fa-question-circle"
        />
      </Tooltip>
    </>
  );
};
